import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { Category, VideoProduct, videoProductToRoute } from 'helper/videos';
import './index.scss';

export default function VideoTab({
  category,
  product,
}: {
  category: Category,
  product: VideoProduct,
}) {
  const currentId = useParams().id;
  const productPath = videoProductToRoute[product];
  const path = `${productPath}/categories/${category.id}`;
  const active = currentId && parseInt(currentId, 10) === category.id;

  return (
    <Link
      to={path}
      className={`nav-link text-uppercase video-tab ${active ? 'active' : ''}`}
    >
      {category.label}
    </Link>
  );
}
